import React, { useContext } from "react";
import {
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Typography,
  Divider,
  Box,
  Avatar,
  Stack,
  Card,
} from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import NotificationsOffOutlinedIcon from "@mui/icons-material/NotificationsOffOutlined";
import { UserContext } from "../../context/UserContext";
import BackBtn from "../../../widgets/BackBtn";
import useApiEp from "../../../hooks/useApiEp";

const NotificationsList = () => {
  const { user, loading } = useContext(UserContext);
  const {
    data: notifications,
    isLoading,
    isError,
  } = useApiEp(`/user/get-my-notifications`);

  return (
    <Box>
      <BackBtn />
      <Card
        elevation={0}
        sx={{
          maxWidth: 800,
          ml: "auto",
          mr: "auto",
          mt: 2,
          borderRadius: 4,
          border: "1px solid #eef2f6",
          boxShadow: "0 4px 24px rgba(0,0,0,0.03)",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            p: 3,
            borderBottom: "1px solid #f1f5f9",
            backgroundColor: "#f8fafc",
          }}
        >
          <Stack direction="row" alignItems="center" spacing={2}>
            <Avatar sx={{ bgcolor: "#0ea5e9", width: 40, height: 40 }}>
              <NotificationsIcon sx={{ color: "white" }} />
            </Avatar>
            <Typography variant="h5" fontWeight={800} color="#1e293b">
              Notifications
            </Typography>
          </Stack>
        </Box>

        {!notifications || notifications.length === 0 ? (
          <Box sx={{ py: 10, textAlign: "center" }}>
            <NotificationsOffOutlinedIcon
              sx={{ fontSize: 60, color: "#cbd5e1", mb: 2 }}
            />
            <Typography variant="h6" color="#64748b" fontWeight={600}>
              No new notifications
            </Typography>
            <Typography variant="body2" color="#94a3b8">
              You're all caught up! Check back later for updates.
            </Typography>
          </Box>
        ) : (
          <List sx={{ p: 0 }}>
            {notifications.map((notification, index) => (
              <React.Fragment key={notification.id}>
                <ListItem
                  component={"a"}
                  href={
                    notification.type === "chat"
                      ? `/${user?.role}/my-chats`
                      : `/${user?.role}/meetings`
                  }
                  sx={{
                    textDecoration: "none",
                    px: 3,
                    py: 2,
                    transition: "all 0.2s ease",
                    "&:hover": {
                      backgroundColor: "#f0f9ff",
                      cursor: "pointer",
                      "& .notification-icon-bg": {
                        backgroundColor: "#0ea5e9",
                        color: "#fff",
                      },
                    },
                  }}
                >
                  <ListItemIcon>
                    <Avatar
                      className="notification-icon-bg"
                      sx={{
                        bgcolor: "#e0f2fe",
                        color: "#0369a1",
                        width: 48,
                        height: 48,
                        transition: "all 0.2s ease",
                      }}
                    >
                      {notification.type === "chat" ? (
                        <ChatBubbleOutlineIcon />
                      ) : notification.type === "meeting" ? (
                        <EventAvailableIcon />
                      ) : (
                        <NotificationsIcon />
                      )}
                    </Avatar>
                  </ListItemIcon>
                  <ListItemText
                    sx={{ ml: 2 }}
                    primary={
                      <Typography
                        variant="body1"
                        fontWeight={600}
                        color="#334155"
                        mb={0.5}
                      >
                        {notification.message}
                      </Typography>
                    }
                    secondary={
                      <Typography
                        variant="body2"
                        color="#94a3b8"
                        fontWeight={500}
                      >
                        {new Date(notification.createdOn).toLocaleString(
                          undefined,
                          {
                            weekday: "short",
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                          }
                        )}
                      </Typography>
                    }
                  />
                </ListItem>
                {index < notifications.length - 1 && (
                  <Divider sx={{ borderColor: "#f1f5f9" }} />
                )}
              </React.Fragment>
            ))}
          </List>
        )}
      </Card>
    </Box>
  );
};

export default NotificationsList;
